var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"overlord-separator",class:{ appended: _vm.appended }},[_vm._v("als Oberherr:")])
}
var staticRenderFns = []

export { render, staticRenderFns }